import * as React from "react";
const SvgRefreshCw01 = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M1.965 12C1.965 6.458 6.458 1.965 12 1.965c2.772 0 5.284 1.125 7.099 2.941.619.62 1.279 1.38 1.866 2.092V4a1.035 1.035 0 0 1 2.07 0v6c0 .572-.463 1.035-1.035 1.035h-6a1.035 1.035 0 0 1 0-2.07h3.895c-.683-.856-1.521-1.855-2.261-2.595A7.965 7.965 0 1 0 12 19.965a7.97 7.97 0 0 0 7.654-5.752 1.035 1.035 0 0 1 1.989.574c-1.208 4.185-5.067 7.248-9.643 7.248-5.542 0-10.035-4.493-10.035-10.035"
}));
export default SvgRefreshCw01;
//# sourceMappingURL=RefreshCw01.js.map